import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _get from 'babel-runtime/helpers/get';
import _inherits from 'babel-runtime/helpers/inherits';
import { UpModule } from './upmodule';
import Result from '../../_interface/result';
export var UpDevice = function (_UpModule) {
    _inherits(UpDevice, _UpModule);

    function UpDevice() {
        _classCallCheck(this, UpDevice);

        var _this = _possibleConstructorReturn(this, (UpDevice.__proto__ || Object.getPrototypeOf(UpDevice)).apply(this, arguments));

        _this.deviceChangeListeners = new Map();
        _this.deviceListChangeListeners = new Map();
        _this.fotaStatusListeners = new Map();
        _this.resourceReportListeners = new Map();
        _this.resourceReportListenersByKey = new Map();
        _this.subscribeResourceReportListeners = new Map();
        _this.bleHistoryListeners = new Map();
        _this.OnBatchDevicesChangedListener = new Map();
        _this.OnBatchDevicesSimplifyChangedListener = new Map();
        _this.oneKeyScannerListener = new Map();
        _this.onDeviceListHandler = function (devList) {
            _this.deviceListChangeListeners.forEach(function (listener) {
                if (typeof listener === 'function') {
                    listener(devList);
                }
            });
        };
        _this.onDeviceAttrAndCautionHandler = function (deviceInfo) {
            _this.OnBatchDevicesChangedListener.forEach(function (listener) {
                if (typeof listener === 'function') {
                    listener(deviceInfo);
                }
            });
        };
        _this.onDeviceSimplifyHandler = function (deviceInfo) {
            _this.OnBatchDevicesSimplifyChangedListener.forEach(function (listener) {
                if (typeof listener === 'function') {
                    listener(deviceInfo);
                }
            });
        };
        _this.onFotaStatusHandler = function (mac, status) {
            var listener = _this.fotaStatusListeners.get(mac.indexOf('-') === -1 ? mac + '-' : mac);
            if (typeof listener === 'function') {
                listener(status);
            }
        };
        _this.onBleHistoryDataHandler = function (mac, data) {
            var listener = _this.bleHistoryListeners.get(mac);
            if (typeof listener === 'function') {
                listener(data);
            }
        };
        _this.onResourceReportHandler = function (mac, name, data) {
            var listener = _this.resourceReportListeners.get(mac);
            if (typeof listener === 'function') {
                listener(name, data);
            }
        };
        _this.onSubscribeResourceReportHandler = function (mac, name, data) {
            var listener = _this.subscribeResourceReportListeners.get(name);
            if (typeof listener === 'function' && typeof mac === 'string') {
                listener(name, data);
            }
        };
        _this.onDeviceInfoChangedHandler = function (mac, devInfo) {
            var onDeviceChanged = _this.deviceChangeListeners.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged === null || onDeviceChanged === void 0 ? void 0 : onDeviceChanged.deviceInfoListener(devInfo);
            }
        };
        _this.onSubDevInfoChangedHandler = function (mac, devInfo) {
            var onDeviceChanged = _this.deviceChangeListeners.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged === null || onDeviceChanged === void 0 ? void 0 : onDeviceChanged.subDeviceInfoListener(devInfo);
            }
        };
        _this.onDeviceAlarmChangedHandler = function (mac, alarms) {
            var onDeviceChanged = _this.deviceChangeListeners.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged === null || onDeviceChanged === void 0 ? void 0 : onDeviceChanged.deviceAlarmListener(alarms);
            }
        };
        _this.onSubDevAlarmChangedHandler = function (mac, alarms) {
            var onDeviceChanged = _this.deviceChangeListeners.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged === null || onDeviceChanged === void 0 ? void 0 : onDeviceChanged.subDeviceAlarmListener(alarms);
            }
        };
        _this.onSubDevListChangedHandler = function (mac, devList) {
            var onDeviceChanged = _this.deviceChangeListeners.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged === null || onDeviceChanged === void 0 ? void 0 : onDeviceChanged.subDeviceListListener(devList);
            }
        };
        _this.onBleRealTimeDataHandler = function (mac, data) {
            var onDeviceChanged = _this.deviceChangeListeners.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged === null || onDeviceChanged === void 0 ? void 0 : onDeviceChanged.bleRealTimeDataListener(data);
            }
        };
        _this.onFindNewDevicesHandler = function (mac, scannerDevices) {
            var scanner = _this.oneKeyScannerListener.get(mac);
            if (scanner) {
                scanner === null || scanner === void 0 ? void 0 : scanner.findNewDevices(scannerDevices);
            }
        };
        _this.onUpdateDevicesHandler = function (mac, scannerDevices) {
            var scanner = _this.oneKeyScannerListener.get(mac);
            if (scanner) {
                scanner === null || scanner === void 0 ? void 0 : scanner.updateDevices(scannerDevices);
            }
        };
        _this.onRemoveDevicesHandler = function (mac, scannerDevices) {
            var scanner = _this.oneKeyScannerListener.get(mac);
            if (scanner) {
                scanner === null || scanner === void 0 ? void 0 : scanner.removeDevices(scannerDevices);
            }
        };
        _this.onResourceReportByKeyHandler = function (result) {
            var mac = result === null || result === void 0 ? void 0 : result.mac;
            var name = result === null || result === void 0 ? void 0 : result.name;
            var encode = result === null || result === void 0 ? void 0 : result.encode;
            var listener = _this.resourceReportListenersByKey.get('' + mac + name);
            if (typeof listener === 'function') {
                listener(mac, name, encode);
            }
        };
        return _this;
    }

    _createClass(UpDevice, [{
        key: 'getDeviceList',
        value: function getDeviceList(params) {
            return this.generatePromiseByPluginFunctionWithParams('getDeviceList', params === null || params === void 0 ? void 0 : params.familyId);
        }
    }, {
        key: 'getDeviceInfoById',
        value: function getDeviceInfoById(params) {
            return this.generatePromiseByPluginFunctionWithParams('getDeviceInfoById', params.deviceId);
        }
    }, {
        key: 'getDeviceBindInfo',
        value: function getDeviceBindInfo(params) {
            return this.generatePromiseByPluginFunctionWithParams('getDeviceBindInfo', params.deviceId);
        }
    }, {
        key: 'getSubDevInfoById',
        value: function getSubDevInfoById(params) {
            return this.generatePromiseByPluginFunctionWithParams('getSubDevInfoById', params.deviceId, params.subDevId);
        }
    }, {
        key: 'getSubDevList',
        value: function getSubDevList(params) {
            return this.generatePromiseByPluginFunctionWithParams('getSubDevList', params.deviceId);
        }
    }, {
        key: 'getSubDevListBySubDevId',
        value: function getSubDevListBySubDevId(params) {
            return this.generatePromiseByPluginFunctionWithParams('getSubDevListBySubDevId', params.deviceId);
        }
    }, {
        key: 'isBound',
        value: function isBound(params) {
            return this.generatePromiseByPluginFunctionWithParams('isBound', params.deviceId);
        }
    }, {
        key: 'executeOperation',
        value: function executeOperation(params) {
            return this.generatePromiseByPluginFunctionWithParams('executeOperation', params.deviceId, params === null || params === void 0 ? void 0 : params.subDevId, params === null || params === void 0 ? void 0 : params.groupName, params.command);
        }
    }, {
        key: 'updateDeviceList',
        value: function updateDeviceList(params) {
            var _a;
            return this.generatePromiseByPluginFunctionWithParams('updateDeviceList', (_a = params === null || params === void 0 ? void 0 : params.immediate) !== null && _a !== void 0 ? _a : true);
        }
    }, {
        key: 'addDeviceChangeListener',
        value: function addDeviceChangeListener(mac, listeners) {
            this.deviceChangeListeners.set(mac, listeners);
            return this.generatePromiseByPluginFunctionWithParams('subscribeDeviceChange', mac, {
                subDeviceListListener: this.onSubDevListChangedHandler,
                deviceInfoListener: this.onDeviceInfoChangedHandler,
                subDeviceInfoListener: this.onSubDevInfoChangedHandler,
                deviceAlarmListener: this.onDeviceAlarmChangedHandler,
                subDeviceAlarmListener: this.onSubDevAlarmChangedHandler,
                bleRealTimeDataListener: this.onBleRealTimeDataHandler
            });
        }
    }, {
        key: 'initListeners',
        value: function initListeners(params) {
            return this.generatePromiseByPluginFunctionWithParams('initListeners', params.deviceId);
        }
    }, {
        key: 'addDeviceListChangeListener',
        value: function addDeviceListChangeListener(listener, key) {
            if (key != null) {
                this.deviceListChangeListeners.set(key, listener);
            } else {
                this.deviceListChangeListeners.set(listener.toString(), listener);
            }
            return this.generatePromiseByPluginFunctionWithParams('subscribeDeviceListChange', this.onDeviceListHandler);
        }
    }, {
        key: 'checkBoardFotaInfo',
        value: function checkBoardFotaInfo(params) {
            return this.generatePromiseByPluginFunctionWithParams('checkBoardFotaInfo', params.deviceId, params === null || params === void 0 ? void 0 : params.subDevId);
        }
    }, {
        key: 'fetchBoardFotaStatus',
        value: function fetchBoardFotaStatus(params) {
            return this.generatePromiseByPluginFunctionWithParams('fetchBoardFotaStatus', params.deviceId, params === null || params === void 0 ? void 0 : params.subDevId);
        }
    }, {
        key: 'startBoardFota',
        value: function startBoardFota(params) {
            var _a;
            this.fotaStatusListeners.set(params.deviceId + '-' + ((_a = params === null || params === void 0 ? void 0 : params.subDevId) !== null && _a !== void 0 ? _a : ''), params.fotaListener);
            return this.generatePromiseByPluginFunctionWithParams('startBoardFota', params.deviceId, params === null || params === void 0 ? void 0 : params.subDevId, this.onFotaStatusHandler);
        }
    }, {
        key: 'startBoardFotaWithFotaInfo',
        value: function startBoardFotaWithFotaInfo(params) {
            return this.generatePromiseByPluginFunctionWithParams('startBoardFotaWithFotaInfo', params.deviceId, params === null || params === void 0 ? void 0 : params.subDevId);
        }
    }, {
        key: 'subscribeBoardFOTAStatus',
        value: function subscribeBoardFOTAStatus(params) {
            this.generatePromiseByPluginFunctionWithParams('subscribeBoardFOTAStatus', params.fotaListener);
        }
    }, {
        key: 'unsubscribeBleHistoryData',
        value: function unsubscribeBleHistoryData(params) {
            return this.generatePromiseByPluginFunctionWithParams('unsubscribeBleHistoryDataReport', params.deviceId);
        }
    }, {
        key: 'subscribeBleHistoryData',
        value: function subscribeBleHistoryData(params, listener) {
            this.bleHistoryListeners.set(params.deviceId, listener);
            return this.generatePromiseByPluginFunctionWithParams('subscribeBleHistoryDataReport', params.deviceId, this.onBleHistoryDataHandler);
        }
    }, {
        key: 'subscribeResource',
        value: function subscribeResource(params, resourceReportListener) {
            this.resourceReportListeners.set(params.deviceId, resourceReportListener);
            // console.log('subscribeResource-resourceReportListeners', this.resourceReportListeners);
            return this.generatePromiseByPluginFunctionWithParams('subscribeResource', params.deviceId, params.resName, this.onResourceReportHandler);
        }
    }, {
        key: 'unsubscribeResource',
        value: function unsubscribeResource(params) {
            // console.log('unsubscribeResource', params.deviceId);
            return this.generatePromiseByPluginFunctionWithParams('unsubscribeResource', params.deviceId, params.resName);
        }
    }, {
        key: 'inFocus',
        value: function inFocus(params) {
            return this.generatePromiseByPluginFunctionWithParams('inFocus', params.deviceId);
        }
    }, {
        key: 'outFocus',
        value: function outFocus(params) {
            return this.generatePromiseByPluginFunctionWithParams('outFocus', params.deviceId);
        }
    }, {
        key: 'getErrorCodeAndText',
        value: function getErrorCodeAndText(_code) {
            if (_code === '120000' || _code === '10003') {
                return { code: _code, msg: '设备不存在' };
            } else if (_code === '900003' || _code === '10001') {
                return { code: '120001', msg: '非法参数错误' };
            } else if (_code === '120002' || _code === '20000') {
                return { code: '120002', msg: 'uSDK未启动' };
            } else if (_code === '900000') {
                return { code: '120003', msg: 'uSDK错误' };
            } else if (_code === '900002') {
                return { code: '120005', msg: '指令下发超时' };
            } else if (_code === '900001' || _code === '900004' || _code === '90001') {
                return { code: '120006', msg: '指令无效' };
            } else if (_code === '10002') {
                return { code: '120007', msg: 'JSON转换错误' };
            } else if (_code === '20001') {
                return { code: '120008', msg: 'UpDevice操作失败' };
            } else if (_code === '20002') {
                return { code: '120009', msg: 'UpDevice无效操作' };
            } else if (_code === '20003') {
                return { code: '120010', msg: 'UpDevice操作超时' };
            } else if (_code === '20010') {
                return { code: '120011', msg: '没有WiFi配置信息' };
            } else if (_code === '20011') {
                return { code: '120012', msg: '未找到指定WiFi' };
            } else if (_code === '30001') {
                return { code: '120013', msg: '用户未登录' };
            } else if (_code === '30002') {
                return { code: '120014', msg: '获取程序信息失败' };
            } else if (_code === '30003') {
                return { code: '120015', msg: '获取手机信息失败' };
            }
            return _get(UpDevice.prototype.__proto__ || Object.getPrototypeOf(UpDevice.prototype), 'getErrorCodeAndText', this).call(this, _code);
        }
        // 批量订阅

    }, {
        key: 'batchSubscribeNewDeviceChange',
        value: function batchSubscribeNewDeviceChange(familyId, listener) {
            this.OnBatchDevicesChangedListener.set('publishAttrAndCautionDeviceChange', listener);
            return this.generatePromiseByPluginFunctionWithParams('batchSubscribeNewDeviceChange', familyId, this.onDeviceAttrAndCautionHandler);
        }
        // 批量取消订阅

    }, {
        key: 'batchUnsubscribeNewDeviceChange',
        value: function batchUnsubscribeNewDeviceChange() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2.plugin.batchUnsubscribeNewDeviceChange(function (result) {
                    if (result.retCode === '000000') {
                        document.container.upLogModule.printSucceedResult('batchUnsubscribeNewDeviceChange', result);
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570batchUnsubscribeNewDeviceChange\u6210\u529F', result.retData));
                    } else {
                        document.container.upLogModule.printFailResult('batchUnsubscribeNewDeviceChange', result);
                        reject(new Result('000001', '\u8C03\u7528\u51FD\u6570batchUnsubscribeNewDeviceChange\u5931\u8D25', result.retData));
                    }
                });
            });
        }
    }, {
        key: 'getDeviceModelMixLogicAttrsListBy',
        value: function getDeviceModelMixLogicAttrsListBy(params) {
            return this.generatePromiseByPluginFunctionWithParams('getDeviceModelMixLogicAttrsListBy', params === null || params === void 0 ? void 0 : params.familyId);
        }
    }, {
        key: 'getDeviceNetworkQuality',
        value: function getDeviceNetworkQuality(params) {
            return this.generatePromiseByPluginFunctionWithParams('getDeviceNetworkQuality', params.deviceId);
        }
        // 批量订阅

    }, {
        key: 'batchAttachWitchSimplifyData',
        value: function batchAttachWitchSimplifyData(devices, listener) {
            this.OnBatchDevicesSimplifyChangedListener.set('publishSimplifyDeviceChange', listener);
            return this.generatePromiseByPluginFunctionWithParams('batchAttachWitchSimplifyData', devices, this.onDeviceSimplifyHandler);
        }
        // 批量解除订阅

    }, {
        key: 'batchDetachWitchDeviceIds',
        value: function batchDetachWitchDeviceIds(deviceIds) {
            return this.generatePromiseByPluginFunctionWithParams('batchDetachWitchDeviceIds', deviceIds);
        }
        // 获取当前设备的网络类型

    }, {
        key: 'getNetType',
        value: function getNetType(params) {
            return this.generatePromiseByPluginFunctionWithParams('getNetType', params.deviceId);
        }
        // 解码订阅设备资源

    }, {
        key: 'subscribeResourceWithDecode',
        value: function subscribeResourceWithDecode(params, resourceReportListener) {
            this.subscribeResourceReportListeners.set(params.resName, resourceReportListener);
            return this.generatePromiseByPluginFunctionWithParams('subscribeResourceWithDecode', params.deviceId, params.resName, this.onSubscribeResourceReportHandler);
        }
        // 获取当前设备的网络类型

    }, {
        key: 'fetchGroupableDeviceList',
        value: function fetchGroupableDeviceList(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('fetchGroupableDeviceList', deviceId);
        }
        // 创建分组

    }, {
        key: 'createDeviceGroup',
        value: function createDeviceGroup(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('createDeviceGroup', deviceId);
        }
        // 向组设备中添加设备，要求当前device对象为组设备

    }, {
        key: 'addDevicesToGroup',
        value: function addDevicesToGroup(deviceId, deviceIds) {
            return this.generatePromiseByPluginFunctionWithParams('addDevicesToGroup', deviceId, deviceIds);
        }
        // 向组设备中添加设备，要求当前device对象为组设备

    }, {
        key: 'removeDevicesFromGroup',
        value: function removeDevicesFromGroup(deviceId, deviceIds) {
            return this.generatePromiseByPluginFunctionWithParams('removeDevicesFromGroup', deviceId, deviceIds);
        }
        // 删除组设备，要求当前device对象为组设备

    }, {
        key: 'deleteDeviceGroup',
        value: function deleteDeviceGroup(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('deleteDeviceGroup', deviceId);
        }
        // 组设备获取当前组内的所有子设备，非组设备返回空集合

    }, {
        key: 'getGroupMemberList',
        value: function getGroupMemberList(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('getGroupMemberList', deviceId);
        }
        // 是否为组设备

    }, {
        key: 'isGroup',
        value: function isGroup(params) {
            return this.generatePromiseByPluginFunctionWithParams('isGroup', params.deviceId);
        }
        // 开始设备固件升级指令

    }, {
        key: 'startFOTAWithDeviceFOTA',
        value: function startFOTAWithDeviceFOTA(params) {
            return this.generatePromiseByPluginFunctionWithParams('startFOTAWithDeviceFOTA', params);
        }
        // 获取云存视频可播放日期信息

    }, {
        key: 'getCloudVideoDateListByTimezone',
        value: function getCloudVideoDateListByTimezone(params) {
            return this.generatePromiseByPluginFunctionWithParams('getCloudVideoDateListByTimezone', params);
        }
        // 获取云存回放文件列表

    }, {
        key: 'getCloudVideoPlayListByDeviceId',
        value: function getCloudVideoPlayListByDeviceId(params) {
            return this.generatePromiseByPluginFunctionWithParams('getCloudVideoPlayListByDeviceId', params);
        }
        // 获取云存回放 m3u8 播放地址

    }, {
        key: 'getVideoPlayAddressByDeviceId',
        value: function getVideoPlayAddressByDeviceId(params) {
            return this.generatePromiseByPluginFunctionWithParams('getVideoPlayAddressByDeviceId', params);
        }
    }, {
        key: 'isSupportOneKeyConnect',
        value: function isSupportOneKeyConnect(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('isSupportOneKeyConnect', deviceId);
        }
    }, {
        key: 'subscribeOneKeyScanner',
        value: function subscribeOneKeyScanner(deviceId, listener) {
            this.oneKeyScannerListener.set(deviceId, listener);
            return this.generatePromiseByPluginFunctionWithParams('subscribeOneKeyScanner', deviceId, {
                findNewDevicesHandler: this.onFindNewDevicesHandler,
                updateDevicesHandler: this.onUpdateDevicesHandler,
                removeDevicesHandler: this.onRemoveDevicesHandler
            });
        }
    }, {
        key: 'unsubscribeOneKeyScanner',
        value: function unsubscribeOneKeyScanner(deviceId) {
            this.oneKeyScannerListener['delete'](deviceId);
            return this.generatePromiseByPluginFunctionWithParams('unsubscribeOneKeyScanner', deviceId);
        }
    }, {
        key: 'startScanConfigurableDevice',
        value: function startScanConfigurableDevice(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('startScanConfigurableDevice', deviceId);
        }
    }, {
        key: 'stopScanConfigurableDevice',
        value: function stopScanConfigurableDevice(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('stopScanConfigurableDevice', deviceId);
        }
    }, {
        key: 'getConfigurableDeviceList',
        value: function getConfigurableDeviceList(deviceId) {
            return this.generatePromiseByPluginFunctionWithParams('getConfigurableDeviceList', deviceId);
        }
    }, {
        key: 'bindOneKeyConnectDevice',
        value: function bindOneKeyConnectDevice(deviceId, bindDeviceIds, listener) {
            var result = this.generatePromiseByPluginFunctionWithParams('bindOneKeyConnectDevice', deviceId, bindDeviceIds, function (bindDeviceId, bindProgress) {
                if (listener) {
                    listener === null || listener === void 0 ? void 0 : listener.progressNotify(bindDeviceId, bindProgress);
                }
            });
            return result;
        }
    }, {
        key: 'connectDevice',
        value: function connectDevice(params) {
            return this.generatePromiseByPluginFunctionWithParams('connectDevice', params.deviceId);
        }
    }, {
        key: 'disconnectDevice',
        value: function disconnectDevice(params) {
            return this.generatePromiseByPluginFunctionWithParams('disconnectDevice', params.deviceId);
        }
    }, {
        key: 'wakeUp',
        value: function wakeUp(params) {
            return this.generatePromiseByPluginFunctionWithParams('wakeUp', params.deviceId);
        }
    }, {
        key: 'getSleepState',
        value: function getSleepState(params) {
            return this.generatePromiseByPluginFunctionWithParams('getSleepState', params.deviceId);
        }
    }, {
        key: 'qcConnectDevice',
        value: function qcConnectDevice(params) {
            return this.generatePromiseByPluginFunctionWithParams('qcConnectDevice', params.deviceId);
        }
    }, {
        key: 'qcDisconnectDevice',
        value: function qcDisconnectDevice(params) {
            return this.generatePromiseByPluginFunctionWithParams('qcDisconnectDevice', params.deviceId);
        }
    }, {
        key: 'addQCConnectDeviceTimeOutListener',
        value: function addQCConnectDeviceTimeOutListener(listener) {
            this.generatePromiseByPluginFunctionWithParams('addQCConnectDeviceTimeOutListener', listener);
        }
    }, {
        key: 'subscribeResourceWithDecodeByKey',
        value: function subscribeResourceWithDecodeByKey(params, resourceReportListener) {
            // 判断resourceReportListenersByKey是否为空，为空需要先注册前端onUplusReportDeviceReceive自定义事件
            if (this.resourceReportListenersByKey.size === 0) {
                document.container.addEventListener('onUplusReportDeviceReceive', this.onResourceReportByKeyHandler);
            }
            // 从当前的监听回调查询该设备监听是否存在
            var key = params.deviceId + params.resName;
            var eventListeners = this.resourceReportListenersByKey.get(key);
            // console.log('subscribeResourceByKey-eventListeners', eventListeners);
            if (!eventListeners) {
                // 当前没有注册改设备监听
                // 添加监听
                this.resourceReportListenersByKey.set(key, resourceReportListener);
                // console.log('subscribeResourceByKey-resourceReportListenersByKey', this.resourceReportListenersByKey);
                // 添加监听
                return new Promise(function (resolve, reject) {
                    window.AlipayJSBridge.call('subscribeResourceWithDecode', params, function (ret) {
                        if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                            resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570subscribeResource\u6210\u529F', ret.retData));
                        } else {
                            reject(new Result(ret === null || ret === void 0 ? void 0 : ret.retCode, '\u8C03\u7528\u51FD\u6570subscribeResource\u5931\u8D25,\n              errMsg:' + (ret.retInfo || ret.message), ret.retData || ''));
                        }
                    });
                });
            } else {
                // console.log('subscribeResourceByKey-else', this.resourceReportListenersByKey);
                return new Promise(function (resolve) {
                    resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570subscribeResource\u6210\u529F'));
                });
            }
        }
    }, {
        key: 'unsubscribeResourceByKey',
        value: function unsubscribeResourceByKey(params) {
            // console.log('unsubscribeResourceByKey', params.deviceId);
            var key = params.deviceId + params.resName;
            var eventListeners = this.resourceReportListenersByKey.get(key);
            // console.log('unsubscribeResourceByKey-eventListeners', eventListeners);
            if (eventListeners) {
                // 当前有注册该设备监听
                this.resourceReportListenersByKey['delete'](key);
                // console.log('unsubscribeResourceByKey-eventListeners-delete', eventListeners);
                if (this.resourceReportListenersByKey.size === 0) {
                    // console.log('unsubscribeResourceByKey-removeEventListener');
                    document.container.removeEventListener('onUplusReportDeviceReceive', function () {
                        return false;
                    });
                }
                return new Promise(function (resolve, reject) {
                    window.AlipayJSBridge.call('unsubscribeResource', params, function (ret) {
                        if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                            resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570unsubscribeResource\u6210\u529F', ret.retData));
                        } else {
                            reject(new Result(ret === null || ret === void 0 ? void 0 : ret.retCode, '\u8C03\u7528\u51FD\u6570unsubscribeResource\u5931\u8D25,\n              errMsg:' + (ret.retInfo || ret.message), ret.retData || ''));
                        }
                    });
                });
            } else {
                return new Promise(function (reject) {
                    reject(new Result('000001', '\u8C03\u7528\u51FD\u6570unsubscribeResourceByKey\u5931\u8D25'));
                });
            }
        }
    }, {
        key: 'getAppFuncModelForDevice',
        value: function getAppFuncModelForDevice(params) {
            return this.generatePromiseByPluginFunctionWithParams('getAppFuncModelForDevice', params.deviceId);
        }
    }]);

    return UpDevice;
}(UpModule);